import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';
import type { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { getItemPath, getPathForHistory } from 'reactApp/modules/viewer/sagas/navigate.saga';
import { generateUuidV4 } from 'reactApp/utils/helpers';

export const isEnabledMultiWindow = () => {
    const userAgent = window.navigator?.userAgent;
    return isFeature('multi-window') && Boolean((window as any).qt) && IS_MY_TEAM && userAgent.includes('VKT/desktop');
};

export const openNewWindow = (url: string) => {
    const hasOrigin = /^https?:\/\//i.test(url);
    const fullUrl = hasOrigin ? new URL(url) : new URL(url, window.location.origin);

    fullUrl.searchParams.set('inWindow', 'true');
    import('reactApp/modules/vkTeam/vkTeam.module').then((module) => {
        module.vkTeamsBridge
            .send('OpenModal', {
                url: fullUrl.href,
                uid: generateUuidV4(),
                size: {
                    width: '65%',
                    height: '85%',
                },
                minSize: {
                    width: 840,
                    height: 640,
                },
            })
            .catch((error) => {
                console.error(error);
            });
    });
};

export const getWindowUrl = (storage: EStorageType, item: CloudItem) => {
    const { fullPath } = getItemPath(storage, item);
    return getPathForHistory(fullPath, storage);
};

export const isOpenInWindow = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get('inWindow') === 'true';
};

export const interceptDeeplinkSubscribe = () => {
    if (isEnabledMultiWindow()) {
        import('reactApp/modules/vkTeam/vkTeam.module').then((module) => {
            module.vkTeamsBridge.subscribe('InterceptDeeplink', ({ url }) => {
                if (url) {
                    openNewWindow(url);
                }
            });
        });
    }
};
